"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientConstants = void 0;
exports.ClientConstants = Object.freeze({
    MIN_MAX_FEE_PER_GAS: 5000000000n,
    CALLBACK_GAS_LIMIT: 100000,
});
//# sourceMappingURL=constants.js.map